const GRID_SIZE = 20;

const SQUARE_SIZE = 1;

const ANIMATION_DURATION = 500;

export default class Ripple {
  constructor(el, left, top) {
    this.$container = document.createElement('div');
    this.$container.classList.add('canvas-container');

    this.$canvas = document.createElement('canvas');
    this.context = this.$canvas.getContext('2d');

    this.color = el.getAttribute('data-ripple-color');

    const elBounds = el.getBoundingClientRect();
    this.canvasWidth = elBounds.width;
    this.canvasHeight = elBounds.height;
    this.$canvas.width = this.canvasWidth;
    this.$canvas.height = this.canvasHeight;

    this.canvasMaxSize = Math.max(this.canvasWidth, this.canvasHeight);
    this.rippleCenterX = left;
    this.rippleCenterY = top;

    this.$container.appendChild(this.$canvas);
    el.appendChild(this.$container);

    this.squares = [];

    this.initDate = new Date().getTime();

    this.isRippleComplete = false;

    this.init();
    this.draw();
  }

  init() {
    for (let x = 0; x < this.canvasWidth / SQUARE_SIZE; x++) {
      for (let y = 0; y < this.canvasHeight / SQUARE_SIZE; y++) {
        const posX = x * SQUARE_SIZE;
        const posY = y * SQUARE_SIZE;
        const centerX = posX + SQUARE_SIZE * 0.5;
        const centerY = posY + SQUARE_SIZE * 0.5;

        if (
          Math.pow(this.rippleCenterX - centerX, 2) +
          Math.pow(this.rippleCenterY - centerY, 2) <
          Math.pow(this.canvasMaxSize, 2)
        ) {
          this.squares.push(new Square(this.context, posX, posY));

        }
      }
    }

    window.requestAnimationFrame(this.draw.bind(this));
  }

  draw() {
    if (this.isRippleComplete) {
      return;
    }

    this.context.clearRect(0, 0, this.canvasWidth, this.canvasHeight);

    const newDate = new Date().getTime();
    const currentDate = newDate - this.initDate;

    this.context.fillStyle = this.color;

    let isOver = true;
    for (const square of this.squares) {
      square.draw(currentDate, this.rippleCenterX, this.rippleCenterY);
      if (!square.isAnimationFinished) {
        isOver = false;
      }
    }

    this.isRippleComplete = isOver;

    if (isOver) {
      this.$container.remove();
    }

    window.requestAnimationFrame(this.draw.bind(this));
  }
}

class Square {
  constructor(context, x, y) {
    this.context = context;
    this.x = x;
    this.y = y;
    this.isAnimationFinished = false;
    this.alpha = Math.random() * 0.2;
  }

  draw(date, rippleCenterX, rippleCenterY) {
    if (this.isAnimationFinished) {
      return;
    }

    const distanceFromCenter = Math.sqrt(Math.pow(this.x - rippleCenterX, 2) + Math.pow(this.y - rippleCenterY, 2));
    const delay = distanceFromCenter * 0.7;
    const timeWithDelay = date - delay;
    const scale = timeWithDelay < 0 ? 0 : Math.min(1, Math.max(0, 1 - timeWithDelay / ANIMATION_DURATION));
    
    const scaledSize = SQUARE_SIZE * scale;

    this.context.globalAlpha = this.alpha;
    this.context.fillRect(
      this.x + (SQUARE_SIZE - scaledSize) * 0.5,
      this.y + (SQUARE_SIZE - scaledSize) * 0.5,
      scaledSize,
      scaledSize
    );

    if (timeWithDelay > 0 && scale === 0) {
      this.isAnimationFinished = true;
    }
  }
}